<template>
  <ipo3-page>
    <template slot="title">新聞列表</template>
    <template slot="tools">
      <el-input v-model="form.title" style="width:200px;margin-right:10px;" placeholder="請輸入標題"></el-input>
      
      <el-date-picker
      v-model="form.date"
      type="daterange"
      range-separator="至"
      start-placeholder="開始日期"
      end-placeholder="結束日期" style="margin-right:10px;">
    </el-date-picker>
    <el-select v-model="form.source_id" placeholder="請選擇來源" style="margin-right:10px;">
              <el-option
                v-for="item in sources"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
      </el-select>
    <el-select v-model="form.category_top" placeholder="請選擇分類置頂" style="margin-right:10px;">
              <el-option
                v-for="item in category_tops"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
      </el-select>
      <el-button icon="el-icon-edit" @click="onSearch" type="primary">搜索</el-button>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">添加新聞</el-button>

    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.id==='category_top'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.category_top==1">
                  Y
                </span>
                <span v-else-if="scope.row.category_top==0">
                  N
                </span>
                <span v-else>N</span>
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.create_at|formDate}}
               </template>
            </el-table-column>

            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id, 0)"
                  size="mini"
                  type="success"
                >{{$t('btns.edit')}}</el-button>

                <el-button
                  @click="onDelete(scope.$index, scope.row.id, 0)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "news-index",
  data() {
    return {
      tableData: [],
      isLoading: false,
      category_tops: [{id: '', name: '全部'}, {id: '1', name: '分類置頂'}, {id: '2', name: '非分類置頂'}],
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "類型", id: "type_name" },
        { name: "分類", id: "category_name" },
        { name: "分類置頂", id: "category_top" },
        { name: "瀏覽", id: "read_num" },
        { name: "創建時間", id: "create_at", scope:'time' },
      ],
      form:{
        category_top: '',
        language: 'tw',
        title:'',
        source_id:0,
        date:'',
      },
      sources:[
        {
          id:0,
          name:'全部'
        }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created(){
    let params = this.$route.query;
    this.form.language = params.language;
    this.currentPage = params.page||1;
    this.paginate = params.size||10;
    this.getSources();
    this.getData(this.currentPage,this.paginate,params);
  },  

  watch: {
    $route: {
      async handler(newVal) {
        let params = this.$route.query;
        this.form.language = params.language;
        this.currentPage = params.page||1;
        this.paginate = params.size||10;
        this.getSources();
        this.getData(this.currentPage, this.paginate, params);
      },
      immediate: true,
    }
  },
  methods:{
    getSources(){
      var self = this;
      this.$http.get("/admin/source/index").then(res=>{
        var init_sources = [
              {
                id:0,
                name:'全部'
              }
            ];
        self.sources = init_sources.concat(res.data.data);
      })
    },

    onSearch()
    {
      let params = Object.assign({},this.form);
      if(params.date)
      {
        params.start_time = params.date[0].getTime()/1000;
        params.end_time = params.date[1].getTime()/1000;
      }else{
        params.start_time =0;
        params.end_time = 0;
      }
      delete params.date;
      this.getData(this.currentPage, this.paginate, params);
    },

    getData(page=1,size=10,params={}){
        let self = this;
        this.$http.get("/admin/news/index",{page:page,size:size,...params}).then(res=>{
          let {data,total} = res.data;
          self.pagecount = total;

          data.forEach(element => {
            element.category_name = element.category?element.category.name:'暫無分類';
            element.source_name = element.source?element.source.name:'暫無來源';
            element.type_name = element.type==1?"新聞":"視頻";
          });
            self.tableData =  data;
        })
    },

    onCreate()
    {
        this.$router.push({path:"/news/edit"})
    },

    onHandle(index,id)
    {
        this.$router.push({path:`/news/edit/${id}`})
    },

    handleSizeChange(size)
    {
      let params = Object.assign({},this.form);
      this.paginate = size;
      params.page = 1;
      params.size = this.paginate;
      this.$router.push({path:'/news/index',query:params})
    },

    handleCurrentChange(val)
    {
      let params = Object.assign({},this.form);
      console.log("p:",params);
      params.page = val;
      params.size = this.paginate;
      this.$router.push({path:'/news/index',query:params})
      //this.getData(val,this.paginate,params);
    },

    onDelete(index,id)
    {
      var self = this;
      this.$http.get("/admin/news/delete",{id:id}).then(res=>{
        if(res.code==200)
        {
            //self.getData();
            self.onSearch();
        }
      })
    }
  }
};
</script>